import { ErrorHandler, NgModule, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { IonicModule } from '@ionic/angular';
import * as Sentry from '@sentry/angular';
import {
  ENV_CONFIG,
  FabQuickStartSheetComponent,
  provideTranslation,
  provideTranslationDeps,
  userContextHeadersInterceptor,
  UserStateService
} from '@core';
import { authInterceptor } from '@auth';
import { SzTabBarComponent } from '@ui';
import { environment } from 'src/environment/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { provideFirebase } from './firebase.config';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    IonicModule.forRoot({ mode: 'ios' }),
    AppRoutingModule,
    SzTabBarComponent,
    FabQuickStartSheetComponent
  ],
  providers: [
    provideHttpClient(withInterceptors([userContextHeadersInterceptor, authInterceptor])),
    provideTranslation(),
    ...provideTranslationDeps(),
    { provide: ENV_CONFIG, useValue: environment },
    // Blokujące załadowanie stanu usera z backendu (/users/me) przed renderem,
    // gdy zalogowany. Reaktywne przeładowania login/logout obsługuje sam serwis. ADR-0010.
    provideAppInitializer((): Promise<void> => inject(UserStateService).init()),
    ...provideFirebase(),
    ...(environment.sentryDsn ? [{ provide: ErrorHandler, useValue: Sentry.createErrorHandler() }] : [])
  ]
})
export class AppModule {}
